import { Avatar } from '@mantine/core';

interface EmployeeAvatarProps {
  name?: string;
  avatar?: string;
}

const EmployeeAvatar = ({ name, avatar }: EmployeeAvatarProps) => {
  return (
    <Avatar
      size={32}
      color="initials"
      src={avatar}
      name={name}
      alt=""
      autoContrast
      variant="filled"
    />
  );
};

export default EmployeeAvatar;
